(ns ui.agent.create-modal
  "The modal of the Agents page that creates an agent: a name, Create.
   A created agent closes the modal; its chat gets ready in the
   background and the page shows when it is. In the chat the agent
   asks what it is for. The modal says once what every agent shares:
   the accounts it connects are the organization's, and the credits
   it spends from."
  (:require [clojure.string :as str]
            [parts.replicant.command :as command]
            [storrito.ui.core :as ui]
            [ui.agent.page :as page]))

(def name-path
  [:agent-create/name])

(defn create-command
  [name]
  {:command/kind :command/agent-create
   :command/data {:agent/name name}})

(defn render
  [state]
  (let [name (str (get-in state name-path))
        cmd (create-command (str/trim name))
        issued? (command/issued? state cmd)]
    [:div.py-4
     [:div.text-center
      [:h3 {:class "text-base font-semibold leading-6 text-gray-900"}
       "New agent"]
      [:p {:class "mt-2 text-sm text-gray-500"}
       "Name it after the client or the job it works for. Its chat is ready a few minutes later; there the agent asks what it is for."]]
     [:div.mt-4
      [:label {:for "agent-name"
               :class "block text-sm font-medium leading-6 text-gray-900"}
       "Name"]
      [:div.mt-1
       [:input
        {:id "agent-name"
         :type "text"
         :placeholder "e.g. Bishop Arts District"
         :value name
         :class "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
         :on {:input [[:store/assoc-in name-path :event/target.value]]}}]]]
     [:p {:class "mt-4 text-xs text-gray-500"}
      "What the agent spends at the models is charged to your credits every hour. "
      "The services it connects in its chat (a Google Drive, a Gmail) are connected for the whole organization: "
      "any agent may use or disconnect them."]
     (when-let [error (command/get-latest-error state cmd)]
       [:p {:class "mt-3 text-sm text-red-600"} error])
     [:div.mt-6
      [:button
       {:class (concat ui/button-primary ["w-full"])
        :disabled (or issued? (str/blank? name))
        :on {:click [[:data/command cmd
                      {:on-success [[:data/query page/agents-query]
                                    [:agents/poll]
                                    [:ui/modal-close]]}]]}}
       (if issued? "Creating …" "Create")]]]))

(def modal
  {:modal-id :modal/agent-create
   :on-load (fn [_]
              [[:store/assoc-in name-path ""]])
   :render #'render})
